/* eslint-disable */
import React from "react";
import Typewriter from "typewriter-effect";
import {Row} from "reactstrap"

const TypeWriter = (props) => {

  return (
    <Row>
      {props.prefix}
      &ensp;
      <Typewriter
        options={{
          strings: props.words,
          autoStart: true,
          loop: true,
        }}
      />
      &ensp;
      {props.suffix}
    </Row>
  );
};
    
export default TypeWriter;
